import mediaInfo from "../reducers/creators/mediaInfo";
import { MEDIA_INFO_SCREEN_NAMESPACE } from "../../constants/store/mediaInfo";

export default mediaInfo(MEDIA_INFO_SCREEN_NAMESPACE);
